export const ConsultantCapability = {
    TABLE_SUPPLIERS_VENDOR_LIST: 'table:suppliers:vendor-list',
    TABLE_PO_DEMAND: 'table:purchase-orders:demand',
    TABLE_PO_SUPPLY: 'table:purchase-orders:supply',
    TABLE_INVENTORY_SNAPSHOT: 'table:inventory:snapshot',
    TABLE_INVENTORY_PLANNING: 'table:inventory:planning',
    TABLE_INVENTORY_PIPELINE: 'table:inventory:pipeline',
    TABLE_DEMAND_FORECAST: 'table:demand:forecast-table',
    TABLE_DEMAND_CHART: 'table:demand:chart',
} as const;

export type ConsultantCapabilityKey = typeof ConsultantCapability[keyof typeof ConsultantCapability];
